/*
 * Loading placeholders are blank flaps: squared, one flat step up from the
 * surface they sit on, pulsing rather than sweeping. A travelling gradient
 * would imply motion the board does not have.
 */
export function Skeleton({ className = '' }: { className?: string }) {
  return <div aria-hidden="true" className={`animate-shimmer rounded-[3px] bg-elevated ${className}`} />
}

export function SkeletonText({ lines = 3 }: { lines?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} className={`h-3 ${index === lines - 1 ? 'w-1/2' : 'w-full'}`} />
      ))}
    </div>
  )
}

/** Mirrors `RequestCard` exactly — poster, title, meta — so nothing shifts on load. */
export function SkeletonCard() {
  return (
    <div className="board-row flex gap-3 bg-surface px-3 py-3 sm:gap-4 sm:px-4">
      <Skeleton className="h-21 w-14 shrink-0 sm:h-27 sm:w-18" />
      <div className="flex flex-1 flex-col gap-2 py-0.5">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/3" />
        <Skeleton className="mt-1 h-1.5 w-full" />
      </div>
    </div>
  )
}

export function SkeletonRows({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-2" role="status" aria-label="Loading">
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className="h-11 w-full" />
      ))}
    </div>
  )
}
